import { IError } from '@checkout/errors';
import { IChangeShippingMethodSuccessPayload } from '@checkout/payloadTypes';
import { RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/take';
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { checkoutApi } from 'ys-analytics';
import { RootAction } from '../actions/actionTypes.d';
import { logger } from '../utils/logger';
import ActionTypes from './../actions/actionTypes';
import { ChangeShippingRequestMethodAction } from './../actions/actionTypes.d';
import { changeStepRequest, fetchKCOWidgetRequest, setErrors, shippingMethodChangeSuccess, shipwalletStepSuccess } from './../reducers/checkout';
import { rest } from './../utils/apiUtils';

const { eeCheckoutSteps } = checkoutApi;

export const handleShipwalletStepEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$
    .ofType(ActionTypes.HANDLE_SHIPWALLET_STEP_REQUEST)
    .mergeMap(() =>
      action$.ofType(ActionTypes.FETCH_KCO_WIDGET_SUCCESS)
        .take(1)
        .flatMap(() => Observable.concat(
          of$(changeStepRequest({ step: state$.value.checkout.steps.current + 1 })),
          of$(shipwalletStepSuccess())
        ))
        .startWith(fetchKCOWidgetRequest()));

export const handleKlarnaEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$
    .ofType(ActionTypes.FETCH_KCO_WIDGET_SUCCESS)
    .mergeMap(() => {
      try {
        eeCheckoutSteps.klarnaLoad(state$.value.checkout.selection.currency);
      } catch (err) {
        // tslint:disable-next-line:no-console
        console.error('Enhanced Ecommerce error: ', err);
      }
      return of$();
    });

export const changeShippingMethodEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$
    .ofType(ActionTypes.CHANGE_SHIPPING_METHOD_REQUEST)
    .mergeMap((action: ChangeShippingRequestMethodAction) => {
      const { shippingMethod } = action.payload;

      return fromPromise$(rest.httpPut(`/shipping-methods/${shippingMethod}`))
        .flatMap((response: AxiosResponse<IChangeShippingMethodSuccessPayload>) => {
          const { currency, shippingMethod: responseShippingMethod } = response.data.selection;
          try {
            eeCheckoutSteps.shippingChange(responseShippingMethod, currency);
          } catch (err) {
            // tslint:disable-next-line:no-console
            console.error('Enhanced Ecommerce error: ', err);
          }
          return of$(shippingMethodChangeSuccess(response.data));
        })
        .catch((error: IError) => {
          logger(error);
          return of$(setErrors(error));
        });
    });



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/shipping.ts